export { default as PlayButton } from './PlayButton'
export { default as Coin } from './Coin'
export { default as TadaInno } from './TadaInno'
export { default as LogoMini } from './LogoMini'
export { default as Play } from './Play'
export { default as LogoPADV } from './LogoPADV'
